/* eslint-disable array-callback-return*/

import { Grid, Paper } from "@material-ui/core";
import { getDataBridge } from "App/Component/layout/Manajemen/Dokter/utils";
import {
  InputOptionMaster,
  InputTextMaster,
  MasterButton,
} from "App/Component/ui";
import {
  BASE_URL_VCLAIM,
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance1,
  TYPE_INSTANCE1,
  V1,
} from "App/constants";
import { getUserName } from "App/utils/cookies";
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import useMultipleSelect, {
  validasiMultipleSelect,
} from "hooks/useMultipleSelect";
import React, { useEffect, useState } from "react";
import { LIST_URL_MASTER } from "utils/masters";
import { RESET_STATE_SEP } from "./helpers";
import TableListNoSEP from "./TableListNoSEP";
/**
 * SPIR ADALAH NO KONTROL
 */

function FormRencanaKontrol({
  noBpjs,
  formData,
  setFormData,
  handleTutupModalDanSetNoKontrol,
}) {
  const handleSelectSEP = (row) => {
    setFormData({
      ...formData,
      nomor_sep: row.noSep,
    });
  };

  return (
    <Paper
      className='form-no-rencana-kontrol'
      style={{
        padding: "1rem",
      }}>
      <details id='summary-form-rencana-kontrol'>
        <summary>
          {/* <Title title='Buat Nomor Rencana Kontrol' /> */}
          Buat Nomor Rencana Kontrol
        </summary>

        <InputFormRencanaKontrol
          formData={formData}
          setFormData={setFormData}
          noBpjs={noBpjs}
          handleClickSelect={handleSelectSEP}
          handleTutupModalDanSetNoKontrol={handleTutupModalDanSetNoKontrol}
        />
      </details>
    </Paper>
  );
}

const InputFormRencanaKontrol = ({
  formData,
  setFormData,
  noBpjs,
  handleClickSelect,
  handleTutupModalDanSetNoKontrol,
}) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);
  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  const multipleSelectData = useMultipleSelect([
    {
      url: LIST_URL_MASTER.spesialis.list,
      search: true,
      type_instance: TYPE_INSTANCE1,
      value: "codebridgepolibpjs",
      label: ["name"],
      type_response: "body",
      key: "spesialis",
    },
  ]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    try {
      if (isNull(formData.nomor_surat_kontrol)) {
        await createRencanaKontrol();
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      } else {
        await updateRencanaKontrol();
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      }
    } catch (error) {
      console.log(error);
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
    }
  };

  const createRencanaKontrol = async () => {
    const response = await instance1.post(
      `/bridging`,
      {
        nomor_sep: formData.nomor_sep,
        kode_dokter: formData.kode_dokter.toString(),
        poli_kontrol: formData.kode_poliklinik,
        tgl_rencana_kontrol: formData.tgl_rencana_kontrol,
        user: getUserName(),
      },
      {
        headers: {
          method: "post",
          url: `${BASE_URL_VCLAIM}/${V1}/emr/bridging/rencana-kontrol/insert`,
        },
      }
    );

    if (parseInt(response.data?.body?.metaData.code) === 200) {
      defaultToastSuccess("Success");
      handleTutupModalDanSetNoKontrol(
        response.data.body.response.noSuratKontrol
      );
    } else {
      defaultToastError(response.data?.body?.metaData.message);
    }
  };

  const updateRencanaKontrol = async () => {
    const response = await instance1.post(
      `/bridging`,
      {
        nomor_surat_kontrol: formData.nomor_surat_kontrol,
        nomor_sep: formData.nomor_sep,
        kode_dokter: formData.kode_dokter.toString(),
        poli_kontrol: formData.kode_poliklinik,
        tgl_rencana_kontrol: formData.tgl_rencana_kontrol,
        user: getUserName(),
      },
      {
        headers: {
          method: "put",
          url: `${BASE_URL_VCLAIM}/${V1}/emr/bridging/rencana-kontrol/update`,
        },
      }
    );

    if (parseInt(response.data?.body?.metaData.code) === 200) {
      defaultToastSuccess("Success");
      handleTutupModalDanSetNoKontrol(
        response.data.body.response.noSuratKontrol
      );
    } else {
      defaultToastError(response.data?.body?.metaData.message);
    }
  };

  return (
    <Grid container spacing={3}>
      <Grid item sm={4}>
        <form onSubmit={(e) => handleSubmit(e)}>
          <Grid container spacing={1}>
            <Grid item sm={12}>
              <InputTextMaster
                name='nomor_surat_kontrol'
                label='NO SURAT KONTROL'
                disabled={true}
                readOnly={true}
                id='nomor_surat_kontrol'
                value={formData.nomor_surat_kontrol}
                onChange={handleChange("nomor_surat_kontrol")}
                placeholder='No Surat Kontrol'
              />
            </Grid>
            <Grid item sm={12}>
              <InputTextMaster
                name='nomor_sep'
                label='SEP'
                disabled={true}
                readOnly={true}
                id='nomor_sep'
                value={formData.nomor_sep}
                onChange={handleChange("nomor_sep")}
                placeholder='Nomor SEP'
              />

              {/* <div
                style={{
                  display: "flex",
                }}>
                <InputTextMaster
                  name='nomor_sep'
                  label='Nomor SEP'
                  id='nomor_sep'
                  placeholder='Nomor SEP'
                  value={formData.nomor_sep}
                  onChange={handleChange("nomor_sep")}
                />

                <MasterButton
                  type={"button"}
                  color='lightgreen'
                  name=''
                  size='sm'
                  withIcon={true}
                  onClick={() => setShowListSEP(!showListSEP)}
                  style={{
                    marginTop: "1.5rem",
                    width: "32px",
                    height: "32px",
                  }}
                  icon={
                    <SelectIcon
                      width='16px'
                      height='16px'
                      style={{
                        marginLeft: "-0.5rem",
                      }}
                    />
                  }
                />
              </div> */}
            </Grid>
            <Grid item sm={12}>
              <PilihDokter formData={formData} setFormData={setFormData} />
            </Grid>
            <Grid item sm={12}>
              <InputOptionMaster
                name='kode_poliklinik'
                label='POLIKLINIK'
                id='kode_poliklinik'
                withSearch={true}
                data={validasiMultipleSelect(multipleSelectData, 0)}
                value={formData.kode_poliklinik}
                labelValue={formData.nama_poliklinik}
                onChange={(e) => {
                  if (isNull(e)) {
                    setFormData({
                      ...formData,
                      kode_poliklinik: null,
                      nama_poliklinik: "Pilih Poliklinik",
                    });
                  } else {
                    setFormData({
                      ...formData,
                      kode_poliklinik: e.value,
                      nama_poliklinik: e.label,
                    });
                  }
                }}
              />
            </Grid>
            <Grid item sm={12}>
              <InputTextMaster
                name='tgl_rencana_kontrol'
                label='TGL RENCANA KONTROl'
                id='tgl_rencana_kontrol'
                type='date'
                value={formData.tgl_rencana_kontrol}
                onChange={handleChange("tgl_rencana_kontrol")}
                placeholder='Tgl Rencana Kontrol'
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction='row'
            justifyContent='space-between'
            alignItems='center'>
            <MasterButton
              className={"mt-1"}
              type='button'
              color={"danger"}
              name={"RESET"}
              onClick={() => setFormData(RESET_STATE_SEP)}
              size='md'
            />
            <MasterButton
              className={"mt-1"}
              type='submit'
              color={disabled.color}
              name={disabled.label}
              size='md'
            />
          </Grid>
        </form>
      </Grid>

      <Grid item sm={8}>
        <TableListNoSEP noBpjs={noBpjs} handleClickSelect={handleClickSelect} />
      </Grid>
    </Grid>
  );
};

export const PilihDokter = ({ formData, setFormData }) => {
  const [rows, setRows] = useState([]);

  const setNewData = async () => {
    const response = await getDataBridge();
    const _temp = [];
    if (response.state) {
      response.data.map((item) => {
        _temp.push({
          value: item.kodedokter,
          label: item.namadokter,
        });
      });

      setRows(_temp);
    } else {
      setRows([]);
    }
  };

  useEffect(() => {
    setNewData();
  }, []);

  return (
    <InputOptionMaster
      name='kode_dokter'
      label='DOKTER'
      id='kode_dokter'
      withSearch={true}
      needParse={false}
      value={formData.kode_dokter}
      labelValue={formData.nama_dokter}
      onChange={(e) => {
        if (isNull(e)) {
          setFormData({
            ...formData,
            kode_dokter: null,
            nama_dokter: "Pilih Dokter",
          });
        } else {
          setFormData({
            ...formData,
            kode_dokter: e?.value,
            nama_dokter: e?.label,
          });
        }
      }}
      data={rows}
    />
  );
};

export default FormRencanaKontrol;
